<template>
  <div class="about">
    <h1>Error</h1>
    <p>Page Doesn't Exist</p>
    <router-link to="/">Back to Home</router-link>
  </div>
</template>

<script>
export default {
  created() {
    document.title = "Error";
  },
};
</script>
